import { Grid, Typography, Button } from "@mui/material";
import { useAppDispatch } from "../../redux";
import type { User } from "../../types";
import { deleteAttempsAction } from "../Dashboard/DashboardSlice";

interface WarningModalProps {
  handleClose(): void;
  user: User;
}
export function WarningModal(props: WarningModalProps) {
  const { handleClose, user } = props;
  const dispatch = useAppDispatch();
  return (
    <>
      <Grid container textAlign={"center"}>
        <Typography color={"red"} textAlign={"center"}>
          Deleting this client will permanently remove all associated Paneem attempts and data.
        </Typography>
        <Grid item xs={12} xl={12} textAlign={"center"}>
          <Typography color={"red"} variant="h3" textAlign={"center"}>
            This action is irreversible.
          </Typography>
        </Grid>

        <Typography color={"red"} textAlign={"center"}>
          Are you absolutely certain you want to proceed with deleting this client?
        </Typography>
        <Grid item xs={6} xl={6} textAlign={"center"}>
          <Button
            onClick={async () => {
              await dispatch(deleteAttempsAction(user));
              handleClose();
            }}
            variant="outlined"
          >
            {" "}
            Proceed
          </Button>
        </Grid>
        <Grid item xs={6} xl={6} textAlign={"center"}>
          <Button variant="contained" onClick={handleClose}>
            {" "}
            Cancel
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
